import { h } from 'preact';
import MinusIcon from '../utils/icon/icon-minus.svg';
import PlusIcon from '../utils/icon/icon-plus.svg';
import { useMemo } from 'preact/hooks';

const ProductQuantity = ({ currentVariant, quantity, cart, alreadyAddedQty, changeQuantity, maxQty }) => {
  const setNewQty = (qty) => {
    if (qty && qty < 1) {
      changeQuantity(1);
      return;
    }
    if (maxQty && maxQty > 0 && qty && qty >= maxQty) {
      changeQuantity(maxQty);
      return;
    }

    changeQuantity(qty);
  };
  const onBlur = () => {
    if (!quantity) {
      setNewQty(1);
    }
  };
  const disabledPlus = useMemo(() => {
    //check quantity limit
    if (currentVariant.metafields?.cartValidation && currentVariant.metafields?.cartValidation?.quantityLimit <= (alreadyAddedQty + quantity)) {
      return true
    }
    //check if available even quantity -1 
    if (currentVariant.availableForSale == true && maxQty < 0) {
      return false
    }
    //check if les then max in quantity
    return quantity >= maxQty || (alreadyAddedQty + quantity) >= maxQty
  }, [alreadyAddedQty, cart, quantity, currentVariant])

  return (
    <div
      className="flex min-w-20 h-11 border border-grey-D0 ml-3"
      onBlur={onBlur}
      tabIndex={-1}
    >
      <button
        type="button"
        aria-label={window.TMW.Strings.product.decreaseQuantity}
        className="flex justify-center items-center w-8 focus:ring-offset-0 disabled:text-grey-8 text-white"
        disabled={quantity < 2}
        onClick={() => setNewQty(quantity - 1)}
      >
        <MinusIcon />
      </button>
      <input
        type="number"
        value={quantity}
        aria-label={window.TMW.Strings.product.quantityInput}
        className="border-0 m-0 body-sm  w-4 text-center text-headline-tag p-0 focus:ring-offset-0 focus:ring-0 select-none"
        onChange={(e) => setNewQty(e.target.value)}
        readOnly
      />
      <button
        type="button"
        aria-label={window.TMW.Strings.product.increaseQuantity}
        className="flex justify-center items-center w-7 focus:ring-offset-0 disabled:text-grey-8 text-white"
        disabled={disabledPlus}
        onClick={() => setNewQty(quantity + 1)}
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default ProductQuantity;
